module.exports = __webpack_public_path__ + "img/concepcion.46b5077c.jpg";